import { createStoreContext } from 'ariakit-utils/store';
var RadioContextState = createStoreContext();
export { RadioContextState as R };